import { render, staticRenderFns } from "./erpRemind.vue?vue&type=template&id=7d3197f6&scoped=true&"
import script from "./erpRemind.vue?vue&type=script&lang=js&"
export * from "./erpRemind.vue?vue&type=script&lang=js&"
import style0 from "./erpRemind.vue?vue&type=style&index=0&id=7d3197f6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3197f6",
  null
  
)

export default component.exports